<template>
  <div class="logger-sys-bd tb" v-if="funcView.log_sys_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.wrapper.search" :placeholder="$t('base_sys.jkmcdmhsczr')" @fetch="onPageChange({ page: 1 })" style="margin-right: 10px"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.wrapper.uri" :placeholder="$t('base_sys.qing_qiu_di_zhi')" style="width: 100%; margin-right: 10px" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.wrapper.bizId" :placeholder="$t('base_sys.ye_wuID')" style="width: 100%; margin-right: 10px" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!--  推送角色 -->

        <!-- 操作时间段，-->
        <el-form-item :label="$t('base_sys.cao_zuo_shi_jian')">
          <custom-date-picker
            v-model="formSearch.wrapper.dataTimes"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('base_sys.qing_qiuIP')">
          <el-input v-model="formSearch.wrapper.hostIp" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table index tableCode="systemLog" v-loading="isLoading" :data="systemLogList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['traceId','success']">
        <template slot="traceId" slot-scope="scope">
          <span class="cell-link"  @click="copyLink(scope.row.traceId)">{{scope.row.traceId }}</span>
        </template>
        <template slot="success" slot-scope="scope">
          <span v-if="scope.row.success" style="color: #25b864">{{ $t('Common.com_success') }}</span>
          <span v-else style="color: red">{{ $t('Common.com_fail') }}</span>
        </template>
        <el-table-column :label="$t('Common.com_handle')" fixed="right">
          <template slot-scope="scope">
            <el-button @click="seePaclageItem(scope.row)" type="text" size="mini" v-if="funcView.log_sys_details">{{ funcView.log_sys_details }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <sys-conter-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></sys-conter-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import sysConterDialog from './children/sys_content_dialog';

export default {
  name: 'loggerSys',
  mixins: [resetFormSearchMixins],
  components: {
    sysConterDialog,
  },
  data() {
    return {
      sysList: [],
      isLoading: false,
      // 分页
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        orderType: '',
        appName: [],
        logLevel: [],
        success: [],
        wrapper: {
          applicationName: '',
          creatorIden: '',
          search: '',
          // appName: [],

          createTimeStart: '',
          createTimeEnd: '',
          bizId: '',
          uri: '',
          hostIp: '',
          dataTimes: '',
        },
      },
      // 日志列表
      systemLogList: [],
      totalRows: null,
      // 新增修改弹窗
      dialogVisible: false,
      dialogModel: {},
      link: null,
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getSystemLogList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 拷贝地址
    copyLink(link) {
      this.$copyToClip(link, this.$t('Common.com_copy_success'));
    },
    // 获取列表
    getSystemLogList: function () {
      this.formSearch.wrapper.gmtCreateStart = this.formSearch.wrapper.dataTimes && this.formSearch.wrapper.dataTimes[0] ? this.formSearch.wrapper.dataTimes[0] : undefined;
      this.formSearch.wrapper.gmtCreateEnd = this.formSearch.wrapper.dataTimes && this.formSearch.wrapper.dataTimes[1] ? this.formSearch.wrapper.dataTimes[1] : undefined;

      this.isLoading = true;
      this.$postJSON(apis.logPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const recordsData = res.data.list;
        recordsData.forEach((item) => {
          item.uri = `${item.method}  ${item.uri}`;
        });
        this.systemLogList = recordsData;
        this.totalRows = res.data.total;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.bizId = '';
    //   this.formSearch.uri = '';
    //   this.formSearch.hostIp = '';
    //   this.dataTimes = null; // 生效时间
    //   this.getSystemLogList();
    // },
    // 重写表格列筛选
    filterChange: function (value) {
      this.formSearch = Object.assign(this.formSearch, value);
      this.formSearch.wrapper.appName = this.formSearch.appName.length ? this.formSearch.appName : undefined;
      this.formSearch.wrapper.success = this.formSearch.success.length ? this.formSearch.success : undefined;
      this.formSearch.wrapper.logLevel = this.formSearch.logLevel.length ? this.formSearch.logLevel : undefined;

      this.onPageChange({ page: 1 });
    },
    // 查看推送配置
    seePaclageItem: function (data) {
      this.dialogModel.type = 'see';
      this.dialogModel.title = data.uriDesc;
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getSystemLogList();
    },
  },
};
</script>

<style lang="scss"></style>
